import React, { useState, useEffect } from 'react';
import { identityService } from '../../services';

export const AuthError = () => {
    const [message, setMessage] = useState('');

    useEffect(() => {
        const m = sessionStorage.getItem('auth_last_error') || 'Unknown authentication error.';
        setMessage(m);
    }, []);

    const retry = () => {
        sessionStorage.removeItem('auth_last_error');
        sessionStorage.removeItem('auth_last_error_time');
        identityService.redirectSignIn();
    };

    return (
        <div style={{padding: '2rem'}}>
            <h2>Authentication Error</h2>
            <pre style={{whiteSpace: 'pre-wrap'}}>{message}</pre>
            <button onClick={retry} style={{marginTop: '1rem'}}>Try again</button>
        </div>
    );
};

export default AuthError;
